/*
 * @Description: 折叠面板
 * @Author: yy
 * @Date: 2020-08-13 16:07:22
 * @LastEditors: yy
 * @LastEditTime: 2020-08-17 15:37:59
 */


import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
// @ts-ignore
import s from './Collapse.css';
import Icon from './Icon';


export class Panel extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      status: props.expand || false
    }
  }

  toggle = () => {
    this.setState({
      status: !this.state.status
    })
  }

  render() {
    const {status} = this.state
    const {header, children} = this.props
    return (
      <div className={s.panel}>
        <div className={s.panelHeader} onClick={this.toggle}>
          <Icon className={s.icon} angle={status ? 90 : 0} />
          {header}
        </div>
        <div className={[s.panelContent, status ? '' : s.hide].join(' ')}>{children}</div>
      </div>
    )
  }
}

class Collapse extends React.Component {
  constructor (props) {
    super(props)
  }
  
  render () {
    const {className} = this.props
    return (
      <div className={[s.collapse, className].join(' ')}>
        {this.props.children}
      </div>
    )
  }
}

export default withStyles(s)(Collapse)



// WEBPACK FOOTER //
// src/components/Collapse/Collapse.js